/*
 * Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { SidebarNavItem } from "../bci-sidebar/sidebar-nav-item.model";
import { BreadcrumbsService } from "../../breadcrumbs.service";

import { UserInfo } from "src/app/shared/models/user-info";

@Component({
    selector: "bci-app",
    templateUrl: "./bci-app.component.html",
    styleUrls: ["./bci-app.component.scss"],
    standalone: false
})
export class BciAppComponent implements OnInit, OnChanges {
  @Input() applicationTitle = "";
  @Input() applicationTitleLineTwo: string;
  @Input() sidebarLinks: SidebarNavItem[] = [];
  @Input() sidebarFooterLinks: SidebarNavItem[] = [];
  @Input() showSidebarFooterTime = false;
  @Input() enableDefaultsBreadcrumbs = true;
  @Input() userInfo: UserInfo;

  public navigationItems = [];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.enableDefaultsBreadcrumbs &&
      (changes.sidebarLinks || changes.sidebarFooterLinks)
    ) {
      this.navigationItems = [...this.sidebarLinks, ...this.sidebarFooterLinks];
      this.breadcrumbsService.setNavigationItems(this.navigationItems);
    }
  }
}
